/**
 * 设备二级控制器
 */

import { AssembleCableControl } from "../sub-control/AssembleCableControl";
import { AssembleDeviceControl } from "../sub-control/AssembleDeviceControl";
import { UpdateCableEndControl } from "../sub-control/UpdateCableEndControl";


export const DEVICE_SUB_CONTROL = {
    // 布置设备
    ASSEMBLEDEVICE: { name: "ASSEMBLEDEVICE", needInit: true, cmd: "AssembleDeviceControl", clazz: AssembleDeviceControl },
    // 布置线缆
    ASSEMBLECABLE: { name: "ASSEMBLECABLE", needInit: true, cmd: "AssembleCableControl", clazz: AssembleCableControl },
    // 编辑线缆关系
    UPDATECABLEEND: { name: "UPDATECABLEEND", needInit: true, cmd: "UpdateCableEndControl", clazz: UpdateCableEndControl },
}